var React = require('react');

function CartLight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M44.825 12.104a1 1 0 00-.443-.104H7.106a1 1 0 110-2h37.276a3.001 3.001 0 012.895 3.789L43.17 28.841A7 7 0 0136.418 34h-24.68a1 1 0 110-2h24.68a5.001 5.001 0 004.823-3.685l4.106-15.052a1.001 1.001 0 00-.522-1.16z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 1a1 1 0 011-1h.756a5 5 0 014.893 3.97l6.662 31.648A3 3 0 0016.246 38H39a1 1 0 110 2H16.246a5 5 0 01-4.893-3.97L4.691 4.382A3 3 0 001.756 2H1a1 1 0 01-1-1z","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.172 41.172a4 4 0 115.656 5.656 4 4 0 01-5.656-5.656zM15 42a2 2 0 100 4 2 2 0 000-4zm17.172-.828a4 4 0 115.656 5.656 4 4 0 01-5.656-5.656zM35 42a2 2 0 100 4 2 2 0 000-4z","key":2})]);
}

CartLight.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = CartLight;

CartLight.default = CartLight;
